import { useCallback, useRef, useState } from "react";
import Webcam from "react-webcam";

export const useWebcam = () => {
    const webcamRef = useRef<Webcam>(null);
    const [imgSrc, setImgSrc] = useState<string | null>(null);

    const captureImage = useCallback(() => {
        const imageSrc = webcamRef.current?.getScreenshot();
        imageSrc && setImgSrc(imageSrc);
    }, [webcamRef, setImgSrc]);

    return {
        imgSrc,
        webcamRef,
        setImgSrc,
        captureImage,
    }
};